import * as React from 'react'

import { FieldDataValue } from 'embed/constants'
import { Fields } from 'embed/constants/fields'

import { ApplicationField } from 'embed/components/ApplicationField/container'
import { Product } from 'even-ts-static'
import Wrapper from './../Wrapper'

export interface Props {
  directReferral: boolean
  dispatchBackToStepOne: () => void
  hideLoanPurpose: boolean
  slrLoanPurposeOnChange?: (value: FieldDataValue) => void
  onBack: () => void
  onContinue: () => void
  stepByStepApplicationStepIsValid: boolean
  currentStep: number
  totalNumberOfSteps: number
}

const StepbystepApplicationStepSLRLoanPurpose: React.SFC<Props> = (props) => (
  <Wrapper {...props}>
    <ApplicationField
      field={Fields.LoanPurpose}
      hidden={props.hideLoanPurpose}
      onChange={props.slrLoanPurposeOnChange}
      product={Product.Loan}
    />
  </Wrapper>
)

export default StepbystepApplicationStepSLRLoanPurpose
